// Small InfoOutlined icon that opens a tooltip explaining a
// section. Used across every API Security page so first-time
// operators don't have to leave the page to figure out what a
// table column / chip / counter means.
//
// Usage:
//   <SectionTitle>Discovery <SectionHelp tooltip="Endpoints inferred from observed traffic. Discovery is always-on per site." /></SectionTitle>
//
// Two sizes:
//   - default (16px) for section headings
//   - small (14px) for inline placement next to column headers
//
// The tooltip is wide-friendly (maxWidth 360) so long-form
// explanations don't get awkwardly word-wrapped at 200px.

import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import colors from "../../../../../../utils/colors";

export default function SectionHelp({ tooltip, size = "default", placement = "top" }) {
  if (!tooltip) return null;
  const px = size === "small" ? 14 : 16;
  return (
    <Tooltip
      title={tooltip}
      placement={placement}
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            maxWidth: 360,
            fontSize: 12,
            lineHeight: "18px",
            color: "#fff",
            backgroundColor: "#1F2937",
            "& .MuiTooltip-arrow": { color: "#1F2937" },
            p: 1.5,
          },
        },
      }}
    >
      <IconButton
        size="small"
        sx={{
          p: 0.25,
          ml: 0.5,
          verticalAlign: "middle",
          color: colors.primary?.[300] || "#6371F7",
          "&:hover": { color: colors.primary?.[500] || "#4338ca", backgroundColor: "rgba(99, 113, 247, 0.08)" },
        }}
      >
        <HelpOutlineIcon sx={{ fontSize: px }} />
      </IconButton>
    </Tooltip>
  );
}
